import { Component, inject } from '@angular/core';
import { ButtonComponent } from '@components/shared/button/button.component';
import { VenueLayoutService } from '@services/venue-layout.service';

@Component({
    selector: 'app-venue-layout-button',
    imports: [
        ButtonComponent
    ],
    templateUrl: './venue-layout-button.component.html',
    styleUrl: './venue-layout-button.component.css'
})
export class VenueLayoutButtonComponent {

  // SERVICES
  protected readonly venueLayout: VenueLayoutService = inject(VenueLayoutService);

}
